import React, { useState, useEffect } from 'react';
import { ChevronUp } from 'lucide-react';

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="fixed bottom-6 right-6 z-50 w-10 h-10 rounded-full bg-[#1e3a5f] text-white shadow-lg hover:bg-[#16304d] transition-all duration-200 flex items-center justify-center hover:scale-110 active:scale-95"
      aria-label="Back to top"
      data-testid="back-to-top-btn"
    >
      <ChevronUp className="h-5 w-5" />
    </button>
  );
}
